import {BenchlingDispatch, Thunk} from 'redux-stores/Store';
import * as StorableSchemaDAO from 'samples/StorableSchemaDAO';

import {StarsResponse} from './StarsConstants';

export enum StarsActionType {
  STAR_STORABLE_SCHEMA_COMPLETED = 'STAR_STORABLE_SCHEMA_COMPLETED',
  STAR_BATCH_SCHEMA_COMPLETED = 'STAR_BATCH_SCHEMA_COMPLETED',
  UNSTAR_STORABLE_SCHEMA_COMPLETED = 'UNSTAR_STORABLE_SCHEMA_COMPLETED',
  UNSTAR_BATCH_SCHEMA_COMPLETED = 'UNSTAR_BATCH_SCHEMA_COMPLETED',
  FETCH_STARRED_STORABLE_SCHEMAS_COMPLETED = 'FETCH_STARRED_STORABLE_SCHEMAS_COMPLETED',
  FETCH_STARRED_BATCH_SCHEMAS_COMPLETED = 'FETCH_STARRED_BATCH_SCHEMAS_COMPLETED',
}

export type StarStorableSchemaCompletedAction = StarsResponse & {
  type: StarsActionType.STAR_STORABLE_SCHEMA_COMPLETED;
};

export function starStorableSchemaCompleted({starred}: StarsResponse): StarStorableSchemaCompletedAction {
  return {
    type: StarsActionType.STAR_STORABLE_SCHEMA_COMPLETED,
    starred,
  };
}

export type UnstarStorableSchemaCompletedAction = StarsResponse & {
  type: StarsActionType.UNSTAR_STORABLE_SCHEMA_COMPLETED;
};

export function unstarStorableSchemaCompleted({starred}: StarsResponse): UnstarStorableSchemaCompletedAction {
  return {
    type: StarsActionType.UNSTAR_STORABLE_SCHEMA_COMPLETED,
    starred,
  };
}

export function toggleStorableSchemaStar(storableSchemaId: string): Thunk<void> {
  return (dispatch, getState) => {
    const starredStorableSchemaIds = getState().models.stars.storableSchemaIds || [];
    if (starredStorableSchemaIds.includes(storableSchemaId)) {
      StorableSchemaDAO.unstar([storableSchemaId]).done((resp: StarsResponse) => {
        dispatch(unstarStorableSchemaCompleted(resp));
      });
    } else {
      StorableSchemaDAO.star([storableSchemaId]).done((resp: StarsResponse) => {
        dispatch(starStorableSchemaCompleted(resp));
      });
    }
  };
}

export type FetchStarredStorableSchemasCompletedAction = StarsResponse & {
  type: StarsActionType.FETCH_STARRED_STORABLE_SCHEMAS_COMPLETED;
};

export function fetchStarredStorableSchemasCompleted({
  starred,
}: StarsResponse): FetchStarredStorableSchemasCompletedAction {
  return {
    type: StarsActionType.FETCH_STARRED_STORABLE_SCHEMAS_COMPLETED,
    starred,
  };
}

export function fetchStarredStorableSchemas(): (dispatch: BenchlingDispatch) => void {
  return (dispatch) => {
    StorableSchemaDAO.fetchStarred().done((resp: StarsResponse) => {
      dispatch(fetchStarredStorableSchemasCompleted(resp));
    });
  };
}

export type StarsAction =
  | StarStorableSchemaCompletedAction
  | UnstarStorableSchemaCompletedAction
  | FetchStarredStorableSchemasCompletedAction;
